module.exports = __webpack_public_path__ + "static/media/Cerberus.f210b7c5.jpg";